import type { EntityBatchSyncStatus } from './entityMutationSync'
import { deriveSyncOutcome, type SyncOutcome } from './syncOutcome'

// Thin per-surface wrapper. Logic lives in `deriveSyncOutcome` so every
// surface stays in lockstep (v2.1 finding #24 consolidation). NOTE: the
// surface key is `inventory` but the i18n namespace is `warehouse.sync.*`
// — the consolidated helper preserves that mapping in SURFACE_PREFIX.
export type InventorySyncOutcome = SyncOutcome

export const deriveInventorySyncOutcome = (params: {
  status: EntityBatchSyncStatus
  skippedNotFoundCount: number
}): InventorySyncOutcome => deriveSyncOutcome({ ...params, surfaceKey: 'inventory' })
